// Mensagens claras para os erros do Firebase Authentication (login e cadastro).
// Os textos originais do Firebase são técnicos ("auth/operation-not-allowed").
const MESSAGES = {
  "auth/operation-not-allowed":
    "This sign-in method is turned off for this platform. An administrator must enable it in the Firebase " +
    "console (Authentication → Sign-in method).",
  "auth/email-already-in-use": "There is already an account with this email. Sign in instead, or use “Forgot password”.",
  "auth/invalid-email": "This email address is not valid.",
  "auth/weak-password": "The password must have at least 6 characters.",
  "auth/user-not-found": "Email or password is incorrect.",
  "auth/wrong-password": "Email or password is incorrect.",
  "auth/invalid-credential": "Email or password is incorrect.",
  "auth/invalid-login-credentials": "Email or password is incorrect.",
  "auth/user-disabled": "This account has been disabled. Contact the administrator.",
  "auth/too-many-requests": "Too many attempts. Wait a few minutes and try again.",
  "auth/network-request-failed": "No connection to the authentication service. Check your internet connection.",
  "auth/popup-closed-by-user": "The sign-in window was closed before finishing.",
  "auth/popup-blocked": "The browser blocked the sign-in window. Allow pop-ups for this site and try again.",
  "auth/unauthorized-domain":
    "This address is not authorized for Google sign-in. An administrator must add it in the Firebase console " +
    "(Authentication → Settings → Authorized domains), or use the address already authorized.",
  "auth/account-exists-with-different-credential":
    "This email is already registered with another sign-in method (email and password, or Google). " +
    "Sign in with the method you used before."
};

// Mantém o formato que as telas esperam ({ message }) e preserva o código para diagnóstico
export function friendlyAuthError(error) {
  const code = error && error.code;
  return { code, message: MESSAGES[code] || (error && error.message) || "Unexpected error. Try again." };
}
